import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Empty from "components/Empty";
import Error from "components/Error";
import Loading from "components/Loading";
import ModalInfinityList from "components/ModalInfinityList";
import AnimatedInfinityList from "components/AnimatedInfinityList";

import { styles } from "./styles";
import { sizes, colors, strings } from "assets/constants";

import { useFlag } from "hooks";
import { mq } from "utils";

import { useAttributes } from "clients/apis";

export default function AttrPicker(props: PickerT) {
  const { id, value, onSelect, error, hideError, onPress } = props;
  const val = value as AttributeT;

  const {
    isError,
    error: attrError,
    isRefetching,
    refetch,
    isFetching: attrsFetching,
    data: attrs,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useAttributes();

  const { flg: modal, on: show, off: hide } = useFlag();

  const _onHide = hide;

  const [valueState, setValueState] = useState<AttributeT | undefined>();

  useEffect(() => {
    setValueState(val);
  }, [val]);

  useEffect(() => {
    id && refetch();
  }, [id, refetch]);

  const _renderItem = (items: []) => {
    return items.map((attr: AttributeT, key: number) => (
      <React.Fragment key={String(key)}>
        {key !== 0 && <View style={styles.itemSeparator} />}
        <TouchableOpacity
          activeOpacity={sizes.tapOpacity}
          style={styles.item}
          onPress={() => {
            onSelect && onSelect(attr);
            setValueState(attr);
            hide();
          }}
        >
          <Text>{attr.title}</Text>
        </TouchableOpacity>
      </React.Fragment>
    ));
  };

  const _renderList = () => {
    if (attrsFetching) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error error={attrError} reset={refetch} loading={isRefetching} />;
    }

    if (attrs?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty style={{ minHeight: mq(100) }} message={strings.no_attr} />;
    }

    return (
      <AnimatedInfinityList
        onRefresh={refetch}
        responseData={attrs}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        renderItemList={_renderItem}
      />
    );
  };

  return (
    <>
      <>
        <TouchableOpacity
          onPress={onPress ?? show}
          activeOpacity={sizes.tapOpacity}
          style={{ ...styles.container }}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={styles.textContainer}>
            <Text
              color={
                valueState?.title ? colors.textColorDefault : colors.placeholder
              }
            >
              {valueState?.title || strings.pick_attr}
            </Text>
          </View>

          <View style={styles.iconContainer}>
            <Icon name="layers" />
          </View>
        </TouchableOpacity>

        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <ModalInfinityList visible={modal} close={_onHide}>
        {_renderList()}
      </ModalInfinityList>
    </>
  );
}
